module.exports = __webpack_public_path__ + "img/book1.bf679239.png";